import React from 'react';
import { Eye, Tag, CalendarPlus, Trash2 } from 'lucide-react';

// Quick-actions bottom sheet for a saved product (the ⋮ on a shelf card).
function MenuRow({ icon: Icon, label, onClick, danger }) {
  return (
    <button type="button" onClick={onClick}
      className="w-full flex items-center gap-3 px-5 py-3.5 text-[15px] text-left hover:bg-[#FAF7F2] transition-colors"
      style={{ color: danger ? '#9A5A5A' : '#2A1212' }}>
      <Icon className="h-[18px] w-[18px]" style={{ color: danger ? '#9A5A5A' : '#7a6a58' }} />
      {label}
    </button>
  );
}

export default function ShelfMenu({ product, onClose, onViewDetails, onEditTags, onAddToRoutine, onRemove }) {
  if (!product) return null;
  return (
    <div className="fixed inset-0 z-50" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl pb-7" onClick={(e) => e.stopPropagation()}>
        <div className="w-10 h-1 rounded-full bg-[#E5E0D8] mx-auto my-3" />
        <p className="px-5 text-[13px] uppercase tracking-wide text-[#2A324B]/45 truncate">{product.brand}</p>
        <p className="px-5 pb-2 text-[15px] font-semibold text-[#2A1212] truncate">{product.name}</p>
        <div className="border-t border-[#F1ECE4] mt-1 pt-1">
          <MenuRow icon={Eye} label="View details" onClick={onViewDetails} />
          <MenuRow icon={Tag} label="Edit tags" onClick={onEditTags} />
          <MenuRow icon={CalendarPlus} label="Add to my routine" onClick={onAddToRoutine} />
          <MenuRow icon={Trash2} label="Remove" onClick={onRemove} danger />
        </div>
      </div>
    </div>
  );
}
